module.exports = __webpack_public_path__ + "img/logo-soc.e5e4dd57.png";